module.exports = __webpack_public_path__ + "img/devsheet.5eb4398b.svg";